import { redirect } from "react-router-dom";
import { api } from "services/api.service";
import { withAuth } from "routes/utils/withAuth";

export async function action({ request }: { request: Request }) {
  const formData = await request.formData();
  const id = formData.get("id");
  if (id && id.toString().trim() !== "") {
    return redirect(`/replacement-finder/${id}`);
  } else {
    return redirect("/replacement-finder");
  }
}

export const loader = withAuth(async ({ params }: { params: { inventoryId?: string } }) => {
  const response = await api.get(`/inventories/${params.inventoryId}`);
  return { inventory: response.data };
});
